import axios from "axios";
import { takeLatest, takeEvery, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import CONSTANTS from "../constants.js";

export const FETCH_CURRENT_USER = "saga/revenueBreakdown/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/revenueBreakdown/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_REVENUE_DETAILS_TYPES_SUCCESS =
  "saga/revenueBreakdown/FETCH_REVENUE_DETAILS_TYPES_SUCCESS";

export const SET_LOADING = "saga/revenueBreakdown/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/revenueBreakdown/SET_PREV_PAGE_FILTERS";
export const SET_UPDATES_LOADING = "saga/revenueBreakdown/SET_UPDATES_LOADING";
export const SET_REVENUE_DETAILS_TYPES_CHECKED =
  "saga/revenueBreakdown/SET_REVENUE_DETAILS_TYPES_CHECKED";
export const SET_REVENUE_DETAILS_TYPES_CHECKED_SUCCESS =
  "saga/revenueBreakdown/SET_REVENUE_DETAILS_TYPES_CHECKED_SUCCESS";

export const UPDATE_ALL_DATA = "saga/revenueBreakdown/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/revenueBreakdown/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_REVENUE_DETAILS_TYPES_SUCCESS =
  "saga/revenueBreakdown/UPDATE_REVENUE_DETAILS_TYPES_SUCCESS";

export const FETCH_REVENUE_DETAILS_SUCCESS = "saga/revenueBreakdown/FETCH_REVENUE_DETAILS_SUCCESS";
export const FETCH_REVENUE_DETAILS_BY_TYPE_SUCCESS =
  "saga/revenueBreakdown/FETCH_REVENUE_DETAILS_BY_TYPE_SUCCESS";

export const REMOVE_REVENUE_DETAILS_CATEGORY =
  "saga/revenueBreakdown/REMOVE_REVENUE_DETAILS_CATEGORY";
export const REMOVE_REVENUE_DETAILS_CATEGORY_SUCCESS =
  "saga/revenueBreakdown/REMOVE_REVENUE_DETAILS_CATEGORY_SUCCESS";

export const UPDATE_REVENUE_DETAILS_CHART = "saga/revenueBreakdown/UPDATE_REVENUE_DETAILS_CHART";
export const ADD_REVENUE_DETAILS_CHART = "saga/revenueBreakdown/ADD_REVENUE_DETAILS_CHART";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  removeRevenueCategory: createAction(REMOVE_REVENUE_DETAILS_CATEGORY),
  addRevenueChart: createAction(ADD_REVENUE_DETAILS_CHART),
  setRevenueTypesChecked: createAction(SET_REVENUE_DETAILS_TYPES_CHECKED)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeEvery(REMOVE_REVENUE_DETAILS_CATEGORY, removeRevenueCategory);
  yield takeLatest(UPDATE_REVENUE_DETAILS_CHART, updateRevenueTypesData);
  yield takeLatest(ADD_REVENUE_DETAILS_CHART, updateRevenueTypesData);
}

let date;
let revenueType;

export function* getCurrentUserData({ payload }) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });
  date = payload.date;
  revenueType = payload.revenue_type;

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date, revenue_type: payload.revenue_type };

  const allSagas = [
    getRevenueData({ ...params, date }),
    getRevenueByTypeData({ ...params, date }),
    getRevenueTypesData({ ...params, date })
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });

  date = payload.date;
  revenueType = payload.revenue_type;

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  let params = { short_url, organization_id, date, revenue_type: payload.revenue_type };

  const allSagas = [
    getRevenueData(params),
    getRevenueByTypeData(params),
    getRevenueTypesData(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueData(params) {
  try {
    const revenueResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/totals",
      {
        params
      }
    );
    yield put({ type: FETCH_REVENUE_DETAILS_SUCCESS, payload: revenueResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueByTypeData(params) {
  try {
    const { data } = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/revenue_by_type",
      { params: { ...params, limit: CONSTANTS.MAX_DONUTS } }
    );
    yield put({ type: FETCH_REVENUE_DETAILS_BY_TYPE_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueTypesData(params) {
  try {
    const { data } = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      { params: { ...params, limit: CONSTANTS.MAX_DONUTS } }
    );

    yield put({ type: FETCH_REVENUE_DETAILS_TYPES_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
  }
}

export function* updateRevenueTypesData() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  const checkedRevenueTypeIds = yield select(
    (state) => state.revenueBreakdown.checkedRevenueTypeIds
  );
  const params = {
    short_url,
    organization_id,
    date,
    limit: CONSTANTS.MAX_DONUTS,
    default_revenue_type_ids: checkedRevenueTypeIds.length
      ? checkedRevenueTypeIds.map((rev) => ({ id: rev.id, type: rev.type }))
      : [""],
    revenue_type: revenueType
  };

  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const { data } = yield call(
      axios.post,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      { ...params, revenue_type: revenueType }
    );

    yield put({ type: UPDATE_REVENUE_DETAILS_TYPES_SUCCESS, payload: data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* removeRevenueCategory() {
  const revenuesByType = yield select((state) => state.revenueBreakdown.revenuesByType);
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  let params = {
    short_url,
    organization_id,
    date,
    limit: CONSTANTS.MAX_DONUTS,
    default_revenue_type_ids: revenuesByType.length
      ? revenuesByType.map((rev) => ({ id: rev.id, type: rev.type }))
      : [""],
    revenue_type: revenueType
  };

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      { ...params }
    );

    yield put({ type: REMOVE_REVENUE_DETAILS_CATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}
